import React from 'react';
import {Col, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';

const MessageBody = ({children}) => (
  <Row className="message-body">
    <Col lg={12}>
      {children}
    </Col>
  </Row>
);

MessageBody.propTypes = {
  children: PropTypes.any
};

export default MessageBody;



// WEBPACK FOOTER //
// ./src/components/team/my-messages/message-body.jsx